(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs-SS"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll('.heading');
  const tabContents = document.querySelectorAll('.tab__content');

  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      // Hide all tab contents
      tabContents.forEach(function(content) {
        content.style.display = 'none';
      });

      // Show the clicked tab content
      tabContents[index].style.display = 'block';

      // Remove 'active' class from all tabs
      tabs.forEach(function(tab) {
        tab.classList.remove('active');
      });

      // Add 'active' class to the clicked tab
      tab.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
